import { useMutation } from 'react-query'
import { ApiService, CreateRedirectDto } from '../../api'
import { queryClient } from '../../react-query-provider'

export const useCreateRedirect = () => {
  const { create } = ApiService.Redirects.hooks()

  return useMutation((dto: CreateRedirectDto) => create(dto), {
    onSuccess: () => {
      queryClient.invalidateQueries(['redirects'])
    }
  })
}
